<p-table
  currentPageReportTemplate="Showing {first} - {last} of {totalRecords} items"
  data-test-id="shared-line-select-table"
  dataKey="lineId"
  paginatorDropdownAppendTo="body"
  [alwaysShowPaginator]="true"
  [metaKeySelection]="false"
  [paginator]="true"
  [rows]="10"
  [rowsPerPageOptions]="[10, 15, 25]"
  [scrollable]="true"
  [selectionMode]="isSingleSelect ? 'single' : 'multiple'"
  [showCurrentPageReport]="true"
  [value]="lineData"
  [(selection)]="selected"
  (onRowSelect)="onRowSelect()"
  (onRowUnselect)="onRowUnselect()"
  (onHeaderCheckboxToggle)="onSelectAll()"
>
  <ng-template pTemplate="header">
    <tr>
      @if (!isSingleSelect) {
        <th style="max-width: 4rem;">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
      }
      @for (col of columns; track col.field) {
        <th>
          {{ col.header }}
        </th>
      }
    </tr>
  </ng-template>
  <ng-template let-rowData pTemplate="body">
    @if (isSingleSelect) {
      <tr [pSelectableRow]="rowData">
        <ng-container *ngTemplateOutlet="displayData; context: { rowData }"></ng-container>
      </tr>
    } @else {
      <tr>
        <td>
          <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
        </td>
        <ng-container *ngTemplateOutlet="displayData; context: { rowData }"></ng-container>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="paginatorleft">
    <!-- empty but allows paginator to be pushed to the right -->
  </ng-template>
</p-table>

<ng-template #displayData let-rowData="rowData">
  @for (col of columns; track col.field) {
    <td>
      @switch (col.field) {
        <!-- TODO Due to difference between models for PAC DME and HH products additional ngSwitchCase were added. -->
        <!-- Reducing this options in SwitchCase and aligning date piping will be done in scope of US204969 -->
        @case ('createdDate') {
          {{ rowData[col.field] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
        }
        @case ('createdOn') {
          {{ rowData[col.field] | utcToLocal }}
        }
        @case ('requestReceivedDate') {
          {{ rowData[col.field] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
        }
        @case ('dateTimeFaxRecieved') {
          {{ rowData[col.field] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
        }
        @case ('effectiveFromDate') {
          {{ rowData[col.field] | date: 'MM/dd/yyyy' || '-' }}
        }
        @case ('effectiveToDate') {
          {{ rowData[col.field] | date: 'MM/dd/yyyy' || '-' }}
        }
        @case ('effectiveStartDate') {
          {{ rowData[col.field] | utcDateWithoutTimeZone: 'MM/dd/yyyy' || '-' }}
        }
        @case ('effectiveEndDate') {
          {{ rowData[col.field] | utcDateWithoutTimeZone: 'MM/dd/yyyy' || '-' }}
        }
        @case ('effectiveFrom') {
          {{ rowData[col.field] | utcDateWithoutTimeZone: 'MM/dd/yyyy' || '-' }}
        }
        @case ('effectiveTo') {
          {{ rowData[col.field] | utcDateWithoutTimeZone: 'MM/dd/yyyy' || '-' }}
        }
        @case ('decisionDate') {
          {{ rowData[col.field] | utcToLocal }}
        }
        @case ('downgradeDate') {
          {{ rowData[col.field] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
        }
        @case ('extensionTakenDate') {
          {{ rowData[col.field] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
        }
        @case ('extensionDateTime') {
          {{ rowData[col.field] | utcToLocal }}
        }
        @case ('extensionDate') {
          {{ rowData[col.field] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
        }
        @case ('urgencyDowngradeDate') {
          {{ rowData[col.field] | utcToLocal }}
        }
        @case ('urgencyChangeDate') {
          {{ rowData[col.field] | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
        }
        @case ('statusReason') {
          <span
            class="truncate"
            tooltipPosition="bottom"
            tooltipStyleClass="tooltip-xl-size"
            pTooltip="{{ rowData[col.field] }}"
          >
            {{ rowData[col.field] }}
          </span>
        }
        @default {
          {{ rowData[col.field] }}
        }
      }
    </td>
  }
</ng-template>
